import {contentStepSchema} from "./content-step-schema";
import {specialistStepSchema} from "./specialist-step-schema";
import {relatedArticlesStepSchema} from "./related-articles-step-schema";
import {authorStepSchema} from "./author-step-schema";
import {exercisesStepSchema} from "./exercises-step-schema";
import * as Yup from 'yup';

export const articleFormSchema = Yup
    .object()
    .shape({
        isVisible: Yup.boolean().default(false)
    })
    .concat(contentStepSchema)
    .concat(specialistStepSchema)
    .concat(relatedArticlesStepSchema)
    .concat(authorStepSchema)
    .concat(exercisesStepSchema)

export type ArticleFormSchemaType = Yup.InferType<typeof articleFormSchema>;
